import { useEffect, useState } from "react";

import { onRessincronizar } from "../../services/socket-io";

// Número que sobe toda vez que o tempo real ficou surdo (queda, app em segundo
// plano) e a tela deve buscar de novo o que pode ter perdido. Entra como
// dependência de efeito de busca.
const useRessincronizar = () => {
  const [versao, setVersao] = useState(0);

  useEffect(() => onRessincronizar(() => setVersao((v) => v + 1)), []);

  return versao;
};

export default useRessincronizar;
